import styles from './feature-content.module.less';
import useTranslation from 'next-translate/useTranslation';

/* eslint-disable-next-line */
export interface FeatureContentProps {}

export function FeatureContent(props: FeatureContentProps) {
  const { t } = useTranslation('common');

  return (
    <div className={styles['container']}>
      <h1>{t('welcome_to_feature_content')}</h1>
    </div>
  );
}

export default FeatureContent;
